import titleimg from "../images/titile.png";
import React, { useState } from "react";
import Slider from "react-slick";
import bg1 from "../images/bg1.png";
import bg2 from "../images/bg2.png";
import bg3 from "../images/bg3.png";
import bg4 from "../images/bg4.jpg";

import BannerImage1 from "./BannersComponent/BannerImage1";
import BannerTitle1 from "./BannersComponent/BannerTitle1";
// import BannerText1 from "./BannersComponent/BannerText1";

function BannerSlide() {
  const [slides] = useState([
    {
      id: 1,
      text: "abcgsgsf",
      bImage: bg2,
      bTitle: titleimg,
      bText: "1Vu is the best place for study. You can visit there anytime you want.",
    },
    {
      id: 2,
      text: "abcgsgsf",
      bImage: bg1,
      bTitle: titleimg,
      bText: "2Vu is the best place for study. You can visit there anytime you want.",
    },
    {
      id: 3,
      text: "abcbhghghggsf",
      bImage: bg3,
      bTitle: titleimg,
      bText: "3Vu is the best place for study. You can visit there anytime you want.",
    },
    {
      id: 4,
      text: "abcbhghghggsf",
      bImage: bg4,
      bTitle: titleimg,
      bText: "3Vu is the best place for study. You can visit there anytime you want.",
    }
  ]);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 5000,
    cssEase: "linear"
  };

  return (
    <div>
      <Slider {...settings}>
        {slides.map(function (slide) {
          return (
            <div key={slide.id} id="slider">
              <BannerImage1 bImage={slide.bImage} />
              <BannerTitle1 bTitle={slide.bTitle}  bText={slide.bText} />
              {/* <BannerText1 /> */}
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default BannerSlide;